import { invokeEvent } from 'shared-base';

export let paddleConfig: IPaddleConfig = {} as IPaddleConfig;

try {
  paddleConfig = JSON.parse(import.meta.env.VITE_PADDLE_CONFIG as string);
} catch (e) {
  invokeEvent('sentry', { err: e });
}
